import {Block} from '../../models/Block';
import {Part} from '../../models/Part';
import {Observable, Subscription} from 'rxjs';
import {Presenter} from '../../support/with_presenter';
import {DurationCalculator} from '../../business/duration_calculator/DurationCalculator';

export interface BlockInteractor {
    blocks: Observable<Block[]>;
    add(): void;
    change(updatedBlock: Block): void;
    trash(blockToBeTrashed: Block): void;
    addPart(blockForNewPart: Block, part: Part): void;
    trashPart(partToBeTrashed: Part): void;
}

export class StructurePresenter implements Presenter {
    public blocks: Block[] = [];

    public get totalTimeText(): string {
        const minutes = Math.round(DurationCalculator.ms(this.blocks) / (1000 * 60));

        if (minutes === 1) {
            return `Total time 1 minute`;
        }

        return `Total time ${minutes} minutes`;
    }

    private subscription: Subscription | undefined;

    constructor(private blockInteractor: BlockInteractor) {}

    public mount(): void {
        this.subscription = this.blockInteractor.blocks.subscribe((blocks) => (this.blocks = blocks));
    }

    public unmount(): void {
        this.subscription?.unsubscribe();
    }

    public onAddBlockClick() {
        this.blockInteractor.add();
    }

    public onTrashBlockClick(blockToBeTrashed: Block) {
        this.blockInteractor.trash(blockToBeTrashed);
    }

    public onPartAdd(blockForNewPart: Block, part: Part) {
        this.blockInteractor.addPart(blockForNewPart, part);
    }

    public onPartTrashClick(partToBeTrashed: Part) {
        this.blockInteractor.trashPart(partToBeTrashed);
    }

    public onBlockChange(updatedBlock: Block) {
        this.blockInteractor.change(updatedBlock);
    }
}
